import { createElement, memo, useCallback, useEffect, useRef } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Sensor from '@max/mbc-sensor';
import './index.scss';
function CityList(props) {
    const { groups, onSelectCity, onEmitPositions } = props;
    // 用 ref 收集各分组高度，避免每次 layout 触发 setState 导致无限循环
    const heightsRef = useRef([]);
    const collectedCountRef = useRef(0);
    // 用 ref 存 callback，避免作为 useEffect 依赖
    const onEmitPositionsRef = useRef(onEmitPositions);
    useEffect(() => {
        onEmitPositionsRef.current = onEmitPositions;
    });
    useEffect(() => {
        // groups 变化时重置收集状态
        heightsRef.current = new Array(groups.length).fill(0);
        collectedCountRef.current = 0;
    }, [groups.length]);
    const onGroupLayout = useCallback((index) => (e) => {
        const h = e?.nativeEvent?.layout?.height ?? 0;
        heightsRef.current[index] = h;
        collectedCountRef.current += 1;
        // 所有分组都 layout 完毕后，一次性计算并上报位置
        if (collectedCountRef.current >= groups.length) {
            let acc = 0;
            const positions = heightsRef.current.map(height => {
                const pos = acc;
                acc += height;
                return pos;
            });
            onEmitPositionsRef.current(positions);
        }
    }, [groups.length]);
    return <View className="cfe-city-list">
      {groups.map((group, index) => <Sensor key={group.label} onLayout={onGroupLayout(index)}>
          <Text className="cfe-city-list-letter">{group.label}</Text>
          <View className="cfe-city-list-divider"/>
          {group.data.map(city => <View key={String(city.id)} className="cfe-city-list-item" onClick={() => onSelectCity(city)}>
              <Text className="cfe-city-list-name">{city.name}</Text>
            </View>)}
        </Sensor>)}
      <View className="cfe-city-list-bottom-space"/>
    </View>;
}
export default memo(CityList);
